<template>
  <div class="role-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="roleModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="140">
          <FormItem label="名称" prop="name">
            <Input v-model="roleModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="用户类型" prop="type">
            <Select v-model="roleModel.type" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.userType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="系统预设">
            <i-switch v-model="roleModel.isReserved" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="继承角色" prop="parent">
            <Select v-model="roleModel.parent" filterable placeholder="选择继承的角色">
              <Option v-for="item in roles" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'role-new',
  props: {
  },
  data () {
    return {
      loading: false,
      roleModel: {
        name: null,
        type: null,
        isReserved: false,
        parent: null
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        type: [
          { required: true, type: 'number', message: '请选择用户类型', trigger: 'blur' }
        ]
      },
      roles: []
    }
  },
  watch: {
  },
  mounted () {
    this.initRolesSelect()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    initRolesSelect () {
      Api.Role.listRoles({
        isReserved: null
      }, 1, 1000).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name
          }
        })
        this.roles = data
      }).catch(err => {
        this.$Message.error('获取角色列表失败!' + err.message)
      })
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Role.addRole(this.roleModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.roleModel= {
                name: null,
                type: null,
                isReserved: false,
                parent: null
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
